import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Watch } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcGrid from "@/components/widgets/EcGrid.vue";
import simplebar from "simplebar-vue";
import { interpret } from "xstate";
import paReviewListingMachine from "./machines/reviewListingMachine";
import { PAReviewSearchModel } from "@/store/models/paReview/paReviewSearchData";
import PAReviewItem from "@/store/models/paReview/paReviewItemDTO";
import { PAReviewModule } from "@/store/modules/paReview.module";
import ReviewComponent from "./components/ReviewComponent.vue";
import { Guid } from "guid-typescript";
import { PACycleRequestModel } from "@/store/models/cycle/paCycleRequestDTO";
import Switches from "vue-switches";
import _ from "lodash";
import CycleReviewsSummary from "./components/CycleReviewsSummary.vue";
let Reviews = /** @class */ (() => {
    let Reviews = class Reviews extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Reviews";
            this.isGridLoading = true;
            this.isPopoverVisible = false;
            this.popoverTarget = "";
            this.showActionableItem = false;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                },
                {
                    text: "Reviews",
                    active: true,
                },
            ];
            this.totalCount = 0;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.cycleStatus = ["All", "Progressing", "Delivered"];
            this.cycleLegend = false;
            this.cycleFilter = false;
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "cycleName",
                    type: "none",
                },
                showActionableItem: false,
                page: 1,
                pageSize: 10,
            };
            this.gridColumns = [
                {
                    field: "cycleName",
                    label: "Cycle Name",
                    filterOptions: {
                        enabled: true,
                        placeholder: "Search Cycle",
                    },
                },
                {
                    field: "period",
                    label: "Period",
                    filterOptions: {
                        enabled: false,
                    },
                    sortable: false,
                },
                {
                    field: "reviewMeetingStatus",
                    label: "Review Meeting Status",
                    //thClass: "text-center",
                    sortable: false,
                },
                {
                    field: "status",
                    label: "Status",
                    sortable: false,
                },
            ];
            this.columns = [
                {
                    field: "cycleName",
                    label: "Cycle Name",
                    sortable: true,
                },
                {
                    field: "period",
                    label: "Period",
                    sortable: false,
                },
                {
                    field: "Reviewees",
                    label: "Reviewees",
                    sortable: false,
                },
                {
                    field: "status",
                    label: "Status",
                    sortable: false,
                },
            ];
            //   MACHINE
            this.machine = paReviewListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.searchData = new PAReviewSearchModel();
            this.cycledta = new PACycleRequestModel();
            this.isGridClearApplied = false;
            this.isPageDirty = false;
            this.selectedCycleStatus = "All";
            this.cycleName = "";
            this.teamName = "All";
            this.employeeName = "";
            this.status = "All";
            this.year = "";
            this.emptyGuids = Guid.createEmpty();
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (!this.isGridClearApplied) {
                var dataz = PAReviewModule.gridParams;
            }
            else {
                PAReviewModule.ClearGridParams(null);
                this.serverParams = {
                    columnFilters: {},
                    sort: this.serverParams.sort,
                    showActionableItem: false,
                    page: 1,
                    pageSize: this.searchData.pageSize,
                };
                this.isGridClearApplied = false;
            }
            if (this.showActionableItem) {
                this.cycledta = new PACycleRequestModel();
                this.serverParams.cycleFilters = new PACycleRequestModel();
                this.searchData = _.cloneDeep({ ...this.serverParams, columnFilters: filters, operatingStepId: this.currentStepId, showActionableItem: this.showActionableItem });
            }
            else {
                if (dataz != null && Object.keys(dataz).length != 0) {
                    this.searchData = _.cloneDeep({ ...this.serverParams, columnFilters: filters, operatingStepId: this.currentStepId, cycleFilters: dataz.cycleFilters, showActionableItem: this.showActionableItem });
                }
                else {
                    this.searchData = _.cloneDeep({ ...this.serverParams, columnFilters: filters, operatingStepId: this.currentStepId, cycleFilters: this.cycledta, showActionableItem: this.showActionableItem });
                }
            }
            PAReviewModule.AssignParams(this.searchData);
            this.machineService.send({ type: "GETTING_REVIEWS", searchData: this.searchData });
        }
        onReviewRowClick(params) {
            let reviewComponent = this.$refs["reviewComponentRef"];
            reviewComponent.ShowReviewModal(params.row.reviewId, this.currentStepId);
        }
        onCycleRowClick(params) {
            if (this.currentStep.hasClientInteraction) {
                this.$router.push({ name: "ClientInteraction", params: { cycleId: params.row.cycleId, stepId: this.currentStepId } });
            }
            else {
                this.$router.push({ name: "ReviewExecutor", params: { cycleId: params.row.cycleId, stepId: this.currentStepId } });
            }
        }
        createPAReviewItem(row) {
            return new PAReviewItem(row).formattedDate();
        }
        onTabClicked(tabStepId, clearParams) {
            PAReviewModule.SetReviews([]);
            var filters = [];
            this.initialize();
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (clearParams) {
                if (tabStepId != this.currentStepId) {
                    this.showActionableItem = false;
                    this.cycledta = new PACycleRequestModel();
                    this.serverParams = {
                        columnFilters: {},
                        sort: {
                            field: "cycleName",
                            type: "none",
                        },
                        showActionableItem: false,
                        page: 1,
                        pageSize: 10,
                    };
                }
                PAReviewModule.AssignParams(null);
            }
            var dataz = PAReviewModule.gridParams;
            if (dataz && Object.keys(dataz).length != 0) {
                this.searchData = _.cloneDeep({ ...this.serverParams, columnFilters: filters, operatingStepId: tabStepId, cycleFilters: dataz.cycleFilters, showActionableItem: this.showActionableItem });
            }
            else {
                this.searchData = _.cloneDeep({ ...this.serverParams, columnFilters: filters, operatingStepId: tabStepId, cycleFilters: this.cycledta, showActionableItem: this.showActionableItem });
                this.initialPage = 1;
            }
            PAReviewModule.AssignParams(this.searchData);
            this.machineService.send({ type: "GETTING_REVIEWS", searchData: this.searchData });
        }
        clearDefaults() {
            (this.cycleName = ""), (this.employeeName = ""), (this.year = ""), (this.teamName = "All"), (this.status = "All");
        }
        clearFilter() {
            PAReviewModule.ResetPage();
            var ecgrid = this.$refs["cycle-grid"];
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].cycleFilters = new PACycleRequestModel();
            if (this.cycledta.cycleName || this.cycledta.employeeName || this.cycledta.status != "All" || this.cycledta.teamName != "All" || this.cycledta.pmoTeamId !== null || this.cycledta.year) {
                this.serverParams.columnFilters = {};
                this.isGridClearApplied = true;
                this.clearDefaults();
                this.cycledta = new PACycleRequestModel();
                // ecgrid.$refs.grid.reset();
            }
            this.loadItems();
            this.cycleFilter = false;
        }
        showSummaryStatus(cycleId) {
            if ((this.isPopoverVisible = true)) {
                this.closeCycleSummaryCard();
            }
            this.machineService.send({ type: "SHOW_REVIEW_MEETING_STATUS", cycleId: cycleId });
            this.popoverTarget = `${cycleId}`;
            this.isPopoverVisible = true;
        }
        closeCycleSummaryCard() {
            this.machineService.send({ type: "CLOSE_CYCLE_SUMMARY" });
            this.isPopoverVisible = false;
        }
        selectCycleStatus(statusCycle) {
            this.cycledta.status = statusCycle;
        }
        findLegend(stepName) {
            var value = this.legends.find((legend) => legend.stepName === stepName);
            if (value) {
                return value.stepStyle;
            }
            return null;
        }
        showLegend() {
            this.cycleLegend = !this.cycleLegend;
        }
        closeLegend() {
            this.cycleLegend = false;
        }
        showFilter() {
            this.cycleFilter = !this.cycleFilter;
        }
        closeFilterCard() {
            this.cycleFilter = false;
        }
        get rows() {
            return PAReviewModule.reviews;
        }
        get legends() {
            return PAReviewModule.legends;
        }
        get yearList() {
            return PAReviewModule.yearList;
        }
        get teams() {
            return PAReviewModule.teams;
        }
        get totalReviews() {
            return PAReviewModule.totalCount;
        }
        get allTabs() {
            return PAReviewModule.stepTabs;
        }
        get currentStepId() {
            return this.state.context.searchData.operatingStepId;
        }
        get currentStep() {
            if (PAReviewModule.stepTabs.length > 0) {
                return PAReviewModule.stepTabs.find((x) => x.stepId == this.currentStepId);
            }
            else {
                return null;
            }
        }
        get reviewsSummary() {
            return PAReviewModule.paCycleReviewsStatus;
        }
        get isAnyFilterApplied() {
            return this.cycledta.cycleName || this.cycledta.pmoTeamId || this.cycledta.employeeName || this.cycledta.year || this.cycledta.status;
        }
        AppliedFilters() {
            this.cycleName = this.cycledta.cycleName;
            this.teamName = this.cycledta.teamName;
            this.employeeName = this.cycledta.employeeName;
            this.year = this.cycledta.year;
            this.status = this.cycledta.status;
            if (this.cycledta.pmoTeamId != this.emptyGuids) {
                var team = this.teams.find((x) => x.id == this.cycledta.pmoTeamId);
                if (team != null) {
                    this.teamName = team.value;
                }
                else {
                    this.teamName = "All";
                }
            }
        }
        applyFilter() {
            this.assign();
            this.AppliedFilters();
            this.serverParams.page = 1;
            this.loadItems();
            this.cycleFilter = false;
        }
        assign() {
            PAReviewModule.AssignCycleDataParams(_.cloneDeep(this.cycledta));
        }
        setTeamNameFilter() {
            if (this.cycledta.pmoTeamId) {
                const team = this.teams.find((x) => x.id == this.cycledta.pmoTeamId);
                if (team) {
                    this.cycledta.teamName = team.value;
                }
            }
            else {
                this.cycledta.teamName = "All";
            }
        }
        GetActionableReviews() {
            PAReviewModule.ClearGridParams(null);
            this.clearDefaults();
            this.serverParams.page = 1;
            this.loadItems();
        }
        switchActionableItems(newval, oldval) {
            if (this.state.matches("loadedReviews")) {
                this.GetActionableReviews();
            }
        }
        get isReviewGridFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get isClientInterfacer() {
            return PAReviewModule.isClientInterfacer;
        }
        get gridParams() {
            return PAReviewModule.gridParams;
        }
        get isReportingToManager() {
            return PAReviewModule.isReportingToManager;
        }
        showReviewMeetingStatus() {
            const revieweesIndex = this.columns.findIndex((col) => col.field === "Reviewees");
            const reviewMeetingStatusIndex = this.columns.findIndex((col) => col.field === "reviewMeetingStatus");
            if (reviewMeetingStatusIndex == -1) {
                if (!this.isClientInterfacer && revieweesIndex !== -1) {
                    this.columns.splice(revieweesIndex + 1, 0, {
                        field: "reviewMeetingStatus",
                        label: "Review Meeting Status",
                        thClass: "text-center",
                        sortable: false,
                    });
                }
            }
        }
        initializeForActionableItems() {
            this.showActionableItem = PAReviewModule.showActionableItems;
        }
        initialize() {
            var value = PAReviewModule.gridParams;
            if (value && value.cycleFilters != null) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                this.serverParams.cycleFilters = value.cycleFilters;
                this.cycledta = value.cycleFilters;
                this.showActionableItem = value.showActionableItem;
                this.initialSortBy = value.sort;
                if (value.cycleFilters != null && value.cycleFilters != undefined) {
                    this.cycleName = value.cycleFilters.cycleName;
                    this.employeeName = value.cycleFilters.employeeName;
                    this.status = value.cycleFilters.status;
                    this.year = value.cycleFilters.year;
                    this.teamName = value.cycleFilters.teamName;
                }
            }
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "ReviewExecutor" && from.name != "ClientInteraction") {
                PAReviewModule.ResetPage();
            }
            next();
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
                console.log(this.state.toStrings());
                if (this.state.matches("loadedStepTabs") && this.allTabs.length > 0 && this.state.context.searchData.operatingStepId) {
                    this.onTabClicked(this.state.context.searchData.operatingStepId, false);
                }
                if (this.state.matches("loadedStepTabs") && this.allTabs.length == 0) {
                    this.isGridLoading = false;
                }
                if (this.state.matches("loadedReviews")) {
                    this.totalCount = this.totalReviews;
                    this.isGridLoading = false;
                    this.isPageDirty = true;
                    this.initialPage = 1;
                    this.showReviewMeetingStatus();
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Watch("showActionableItem"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], Reviews.prototype, "switchActionableItems", null);
    Reviews = __decorate([
        Component({
            name: "ReviewListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                ReviewComponent,
                CycleReviewsSummary,
                simplebar,
                Switches,
            },
        })
    ], Reviews);
    return Reviews;
})();
export default Reviews;
